import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../store/session";
// import './ProfileButton.css'
// import { FaTrailer } from "react-icons/fa";
// import { PiTruckTrailerBold } from "react-icons/pi";
// import { FaUser } from "react-icons/fa";
import { IoIosSettings, IoIosHelpCircle, IoIosListBox } from "react-icons/io";
import { BiLogOut } from "react-icons/bi";
import { FaFileContract } from "react-icons/fa";
import { useModal } from "../../context/modal/Modal";
import UserAgreementModal from "../UserAgreementModal";
// import { csrfFetch } from "../../utils/csrfFetch";
// import { useHistory } from "react-router-dom";

function ProfileButton() {
  const dispatch = useDispatch();
  const [showMenu, setShowMenu] = useState(false);
  const ulRef = useRef();
  // const history = useHistory();
  const sessionUser = useSelector((state) => {
    console.log('Redux State:', state);
    console.log('Session State:', state.session);
    return state.session.user;
  });
  const { setModalContent, closeModal } = useModal();

  // Add debugging logs
  useEffect(() => {
    console.log('ProfileButton - Full sessionUser object:', sessionUser);
    if (sessionUser) {
      console.log('User properties:', Object.keys(sessionUser));
      console.log('Alpha code specifically:', sessionUser.alpha_code);
    } else {
      console.log('sessionUser is null or undefined');
    }
  }, [sessionUser]);

  // console.log('ProfileButton sessionUser:', sessionUser);  // Debug Redux state

  const closeMenu = () => setShowMenu(false);

  const openMenu = () => {
    if (showMenu) return;
    setShowMenu(true);
  };

  useEffect(() => {
    if (!showMenu) return;

    const handleClickOutside = (e) => {
      if (!ulRef.current.contains(e.target)) {
        closeMenu();
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [showMenu]);

  const handleLogout = (e) => {
    e.preventDefault();
    dispatch(logout());
  };

  const handleCloseAgreement = (e) => {
    if (e) e.stopPropagation();
    closeModal();
  };

  const showAgreementModal = (e) => {
    if (e) e.stopPropagation();

    // Close the menu first
    closeMenu();

    // Use a small timeout to ensure the menu is closed before opening the modal
    setTimeout(() => {
      const modalContent = (
        <UserAgreementModal
          viewOnly={true}
          onClose={handleCloseAgreement}
        />
      );

      setModalContent(modalContent);
    }, 100);
  };

  // const handleAddUser = () => {
  //   history.push("/signup");
  //   closeMenu();
  // };
  // const handleAddYard = () => {
  //   history.push("/yards/new");
  //   closeMenu();
  // };

  // const handleAddBuilding = () => {
  //   history.push("/buildings/new");
  //   closeMenu();
  // };


  const canAdd = sessionUser?.is_admin || sessionUser?.is_super_manager;

  return (
    <div className="relative z-50">
      <button id='profile-button'
        onClick={openMenu}
        className="flex items-center space-x-2 rounded-lg border-2 border-gray-800 px-3 py-2 transition-all duration-300 hover:bg-gray-100"
      >
        <span className="text-lg font-semibold text-gray-800">
          {sessionUser?.alpha_code}
        </span>
        <img
          className="h-12 w-12 rounded-full object-cover"
          src="/images/user-image.jpeg"
          alt="User"
        />
      </button>

      {showMenu && (
        <div
          ref={ulRef}
          className="absolute right-0 mt-1 w-80 rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
        >
          <div className="py-1">
            <MenuItem
            id = 'profile-button-menu-item'
              icon={<IoIosListBox className="text-blue-600" size={24} />}
              text="Home Page"
              onClick={() => {
                closeMenu();
                window.location.href = '/';
              }}
            />

            {canAdd && sessionUser.is_admin && (
              <>
                <MenuItem
                id = 'profile-button-menu-item'
                  icon={<IoIosListBox className="text-purple-600" size={24} />}
                  text="Admin Dashboard"
                  isAdminOption={true}
                  onClick={() => {
                    closeMenu();
                    window.location.href = '/admin/dashboard';
                  }}
                />
                <MenuItem
                id = 'profile-button-menu-item'
                  icon={<IoIosListBox className="text-blue-600" size={24} />}
                  text="Company List"
                  isAdminOption={true}
                  onClick={() => {
                    closeMenu();
                    window.location.href = '/companies';
                  }}
                />
                <MenuItem
                id = 'profile-button-menu-item'
                  icon={<IoIosListBox className="text-green-600" size={24} />}
                  text="Audit Logs"
                  isAdminOption={true}
                  onClick={() => {
                    closeMenu();
                    window.location.href ='/audit-logs';
                  }}
                />
                <MenuItem
                id = 'profile-button-menu-item'
                  icon={<IoIosSettings className="text-orange-600" size={24} />}
                  text="Settings"
                  isAdminOption={true}
                  onClick={() => {
                    closeMenu();
                    window.location.href ='/settings';
                  }}
                />
              </>
            )}

            <MenuItem
            id = 'profile-button-menu-item'
              icon={<IoIosHelpCircle className="text-blue-600" size={24} />}
              text="User Manual"
              onClick={() => {
                closeMenu();
                window.location.href ="/how-to";
              }}
            />

            <MenuItem
            id = 'profile-button-menu-item'
              icon={<FaFileContract className="text-indigo-600" size={24} />}
              text="User Agreement"
              onClick={showAgreementModal}
            />

            <div className="border-t border-gray-200 my-1"></div>

            <MenuItem
            id = 'profile-button-menu-item'
              icon={<BiLogOut className="text-red-600" size={24} />}
              text="Log Out"
              onClick={handleLogout}
            />
          </div>
        </div>
      )}
    </div>
  );
}

// Helper component for menu items
function MenuItem({ icon, text, onClick, isAdminOption }) {
  return (
    <button id='profile-button-menu-item'
      onClick={onClick}
      className={`flex w-full items-center px-5 py-4 text-left text-xl text-gray-700 hover:bg-gray-100 hover:text-gray-900 transition-colors duration-150 group ${isAdminOption ? 'border border-red-500 rounded-md my-1' : ''}`}
    >
      <span className="mr-4 flex-shrink-0 group-hover:scale-110 transition-transform duration-200">
        {icon}
      </span>
      <span className="font-medium">{text}</span>
    </button>
  );
}

export default ProfileButton;
